import assert from "assert";
import { Edge, Node, Position } from "reactflow";


export class Graph {
    /** A list of all nodes in the graph sorted by uuid. */
    private nodes: Node[]
    private nodeToIndex: Record<string, number>
    /** A list of all edges. */
    private edges: Edge[]
    private edgesFrom: Record<string, number[]>
    private edgesTo: Record<string, number[]>
    changeFlag: boolean;

    constructor() {
        this.nodes = []
        this.edges = []
        this.changeFlag = true;
        this.nodeToIndex = {};
        this.edgesFrom = {};
        this.edgesTo = {};
    }

    addNode(node: Node) {
        this.nodeToIndex[node.id] = this.nodes.push(node) - 1;
        this.changeFlag = true;
    }

    getEdgesFromNode(fromNode: Node) {
        return this.edgesFrom[fromNode.id].map(index => this.edges[index])
    }

    addEdge(from: string, to: string, fromHandle: Position, toHandle: Position) {
        const edge_id = from + to + fromHandle + toHandle

        // don't add duplicates.
        // duplicates can be added in the flowchart conversion if a BlockNode contains a BlockNode.
        // for example: structure is Block -> If -> Block, then the inner Block connects their edges,
        // and the outer Block attempts to connect the edges already connected.
        if(this.edgesFrom[from]) {
            for(const index of this.edgesFrom[from]) {
                if(to == this.edges[index].target) {
                    // duplicate found.
                    return;
                }
            }
        }

        const index = this.edges.push({
            id: edge_id,
            source: from,
            target: to,
            sourceHandle: fromHandle,
            targetHandle: toHandle,
            type: "step",
            deletable: false,
            focusable: false,
            updatable: false
        }) - 1;
        
        // add entry to edgesFrom:
        if(!this.edgesFrom[from]) {
            this.edgesFrom[from] = []
        }
        this.edgesFrom[from].push(index);

        // same as before, add entry to edgesTo:
        if(!this.edgesTo[to]) {
            this.edgesTo[to] = []
        }
        this.edgesTo[to].push(index);

        this.changeFlag = true;
    }

    getEdge(from: Node, to: Node): Edge | undefined {
        const edgesFrom = this.edgesFrom[from.data.uuid];
        const edgesTo = this.edgesTo[to.data.uuid];
        if(!edgesFrom || !edgesTo) {
            return undefined;
        }
        const intersection = edgesFrom.filter(item => edgesTo.includes(item));
        assert(intersection.length <= 1, `more than 1 edges are in the from and to intersection.`);

        const index = intersection[0];
        return this.edges[index];
    }
    hasChanged() {
        const hasChanged = this.changeFlag;
        this.changeFlag = false;
        return hasChanged;
    }

    getNodes() {
        return this.nodes
    }

    getEdges() {
        return this.edges
    }

    getNodeWithUUID(uuid: string): Node|undefined {
        console.log(this.nodes, this.nodeToIndex, this.nodeToIndex[uuid], this.nodes[this.nodeToIndex[uuid]])
        return this.nodes[this.nodeToIndex[uuid]]
    }

}